import {
  AlertColor,
  Card,
  CardContent,
  Grid,
  IconButton,
  Modal,
  Paper,
  Table,
  TableBody,
  TableContainer,
} from '@mui/material';
import { Box } from '@mui/system';
import ButtonComponent from '../../components/formlib/ButtonComponent';
import TitleText from '../../components/formlib/TitleText';
import React, { useContext, useEffect, useRef, useState } from 'react';
import backarrow from '../../assets/images/backarrow.svg';
import MediumTypography from '../../components/formlib/MediumTypography';
import { HeadCell, TableHeader } from '../../components/formlib/TableHeader';
import MyTimeOffTableRow from './MyTimeOffTableRow';
import MyTimeOffModal from './MyTimeOffModal';
import moment from 'moment';
import { ReactComponent as Close } from '../../assets/images/x.svg';
import {
  SELECTED_PROGRAM_KEY,
  STORAGE_USER_ID_KEY,
} from '../../services/Constant';
import { LoaderContext, LoaderContextType } from '../../layouts/AppSidebar';
import {
  TimeOffData,
  addEmployeeMyTimeOff,
  deleteEmployeeMyTimeOff,
  getEmployeeMyTimeOff,
  updateEmployeeMyTimeOff,
  getEmployeeTimeOffBalances,
} from '../../services/myTimeoff/MyTimeoffApi';
import SnackBarComponent from '../../components/formlib/SnackBarComponent';
import SelectComponent from '../../components/formlib/SelectComponent';
import TimeOffBalancesCard, {
  TimeOutLogCardData,
} from './TimeOffBalancesCard';
import { Order, OptionType } from '../../utils/type';
import ModalPopup from '../../components/formlib/ModalPopup';
import {
  ApiError,
  ApiMessage,
  isCustomError,
} from '../../services/ApiResponseHandler';
import AppPagination from '../../components/shared/AppPagination';
import { convertTimeDuration, getFiscalYearInfo } from '../../utils/dateUtil';
import { checkPermissionForFeature } from '../../utils/checkPermission';

export type TimeOffHours = {
  type: string;
  id: string;
  remainingHrs: string;
  employeeType: string;
};

export type TimeOffListType = {
  id?: string;
  typeId: string;
  noOfHrs: string | null;
  durationType: string;
  startDate: string | null;
  endDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  reason: string;
  leaveName: string;
};

export type GetTimeOffListType = {
  id: string;
  typeId: string;
  status: string;
  durationType: string;
  effectiveStartDate: string | null;
  effectiveEndDate?: string | null;
  startTime?: string | null;
  endTime?: string | null;
  reason: string;
  appliedDate: string;
  leaveName: string;
  noOfHrs: string | null;
  totalDays: string;
};

export type EmployeeTypeHistoryList = {
  employeeType: string;
  startDate: string;
  endDate: string;
};

export type MyTimeOffType = {
  leavesInfo: TimeOffHours[];
  timeOffList: GetTimeOffListType[];
  employeeTypeHistoryList: EmployeeTypeHistoryList[];
  totalTimeOffsCount: number;
  employeeType: string;
};

interface TableData {
  type: string;
  createdOn: string;
  duration: string;
  reason: string;
  status: string;
  actions: string;
}
const initialHeadCells: HeadCell<TableData>[] = [
  {
    id: 'createdOn',
    labelId: 'myTimeOffDateApplied',
    defaultLabelId: 'Date Applied',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'type',
    labelId: 'myTimeOffType',
    defaultLabelId: 'Type',
    numeric: false,
    requiredSorting: false,
  },
  {
    id: 'duration',
    labelId: 'myTimeOffDuration',
    defaultLabelId: 'Duration',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'status',
    labelId: 'myTimeOffStatus',
    defaultLabelId: 'Status',
    numeric: false,
    requiredSorting: true,
  },
  {
    id: 'reason',
    labelId: 'myTimeOffReason',
    defaultLabelId: 'Reason',
    numeric: false,
    requiredSorting: false,
  },
];

const style = {
  position: 'absolute' as const,
  top: '45%',
  left: '45%',
  transform: 'translate(-40%, -40%)',
  width: '780px',
  height: 'auto',
  bgcolor: 'background.paper',
  padding: '10px 20px 20px 20px',
  maxHeight: '500px',
  borderRadius: '6px',
  overflowX: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.1)',
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'none',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '4px',
  },
  outline: 'none',
  fontFamily: 'Lato-Regular',
};
const style400 = {
  position: 'absolute' as const,
  top: '45%',
  left: '45%',
  transform: 'translate(-40%, -40%)',
  width: '100%',
  maxWidth: '300px',
  height: 'auto',
  bgcolor: 'background.paper',
  padding: '10px 20px 20px 20px',
  maxHeight: '500px',
  borderRadius: '6px',
  overflowX: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: 'rgba(0, 0, 0, 0.3) rgba(0, 0, 0, 0.1)',
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'none',
  },
  '&::-webkit-scrollbar-thumb': {
    background: 'rgba(0, 0, 0, 0.3)',
    borderRadius: '4px',
  },
  outline: 'none',
  fontFamily: 'Lato-Regular',
};
const MyTimeOff = () => {
  const [myTimeOff, setMyTimeOff] = useState<MyTimeOffType>({
    leavesInfo: [{ type: '', id: '', remainingHrs: '', employeeType: '' }],
    timeOffList: [],
    totalTimeOffsCount: 0,
    employeeType: '',
    employeeTypeHistoryList: [],
  });
  const [showTimeOffModel, setShowTimeOffModel] = useState<boolean>(false);
  const [availableHrs, setAvailableHrs] = useState<boolean>(false);
  const [editRowData, setEditRowData] = useState<TimeOffListType>();
  const [selectedYear, setSelectedYear] = useState<string>('');
  const [page, setPage] = useState<number>(0);
  const [open, setOpen] = React.useState(false);
  const [toastrVariable, setToastrVariable] =
    React.useState<AlertColor>('info');
  const [toastrDefaultMessage, setToastrDefaultMessage] = React.useState('');
  const [order, setOrder] = useState<Order>('desc');
  const [orderBy, setOrderBy] = useState<keyof TableData>('duration');
  const [toastrId, setToastrId] = React.useState('');
  const { loader, toggleLoader } = useContext(
    LoaderContext,
  ) as LoaderContextType;
  const [confirmationModal, setConfirmationModal] = useState<boolean>(false);
  const [deleteTimeOff, setDeleteTimeOff] = useState<GetTimeOffListType | null>(
    null,
  );
  const [fisicalYears, setFisicalYears] = useState<string[]>([]);
  const [startFisicalDateTime, setStartFisicalDateTime] = useState<string>('');
  const [endFisicalDateTime, setEndFisicalDateTime] = useState<string>('');
  const [headCells, setHeadCells] = useState(initialHeadCells);
  const [tbbTimeOffBalances, setTbbTimeOffBalances] = useState<
    TimeOutLogCardData[]
  >([]);

  useEffect(() => {
    const { fiscalYears } = getFiscalYearInfo(new Date());
    if (fiscalYears.length > 0) {
      const currentYearLabel = fiscalYears[fiscalYears.length - 2];
      const [startYear, endYear] = currentYearLabel.split('-').map(Number);
      setStartFisicalDateTime(`07/01/${startYear}`);
      setEndFisicalDateTime(`06/30/${endYear}`);
      setSelectedYear(currentYearLabel);
    }
    setFisicalYears(fiscalYears);
  }, []);

  const handleYearChange = (value: string) => {
    if (value) {
      const [startYear, endYear] = value.split('-').map(Number);
      setStartFisicalDateTime(`07/01/${startYear}`);
      setEndFisicalDateTime(`06/30/${endYear}`);
    }
  };
  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof TableData,
  ) => {
    setOrder(order === 'asc' ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleTimeOff = () => {
    setEditRowData(undefined);
    setShowTimeOffModel(true);
  };

  const onClose = () => {
    setShowTimeOffModel(false);
  };

  const handleAvailableHrs = () => {
    setAvailableHrs(true);
  };

  const onCloseModal = () => {
    setAvailableHrs(false);
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };

  const getEffectiveStartDate = (startDate: string | null) => {
    return startDate ? moment(startDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null;
  };

  const getEffectiveEndDate = (endDate: string | null | undefined) => {
    return endDate ? moment(endDate, 'MM/DD/YYYY').format('YYYY-MM-DD') : null;
  };

  const handleSubmit = async (requestBody: TimeOffListType, action: string) => {
    const employeeId = localStorage.getItem(STORAGE_USER_ID_KEY);

    if (employeeId === null) {
      return;
    }

    toggleLoader(true);

    const effectiveStartDate = getEffectiveStartDate(requestBody.startDate);
    const effectiveEndDate = getEffectiveEndDate(requestBody.endDate);

    const isSameDay = effectiveStartDate === effectiveEndDate;

    const startTime = requestBody.startTime ?? null;

    const durationType = isSameDay ? 'hours' : 'days';

    // Calculate totalDays: weekdays between effectiveStartDate and effectiveEndDate (excluding weekends)
    let totalDays: string | null = null;
    let totalDaysNum: number | null = null;
    if (effectiveStartDate && effectiveEndDate) {
      const startMoment = moment(effectiveStartDate, 'YYYY-MM-DD');
      const endMoment = moment(effectiveEndDate, 'YYYY-MM-DD');
      let count = 0;
      const current = startMoment.clone();
      while (current.isSameOrBefore(endMoment, 'day')) {
        const dayOfWeek = current.day();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          count++;
        }
        current.add(1, 'day');
      }
      totalDaysNum = count;
      totalDays = count.toString();
    }

    // noOfHrs from UI (already a string); '' is treated as missing to match original `||` behavior.
    const rawNoOfHrs = requestBody.noOfHrs ?? null;
    const noOfHrs: string | null = rawNoOfHrs === '' ? null : rawNoOfHrs;

    // Calculate totalHours: noOfHrs * totalDays
    let totalHours: string | null = null;
    if (noOfHrs && totalDaysNum) {
      totalHours = (parseFloat(noOfHrs) * totalDaysNum).toString();
    }

    const utcFisicalYearStartTime = moment(
      startFisicalDateTime,
      'MM/DD/YYYY HH:mm:ss',
    )
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');
    const utcFisicalYearEndTime = moment(
      endFisicalDateTime,
      'MM/DD/YYYY HH:mm:ss',
    )
      .utc()
      .format('YYYY-MM-DDTHH:mm:ss');

    const timeOffPayload: TimeOffData = {
      id: requestBody.id,
      typeId: requestBody.typeId,
      noOfHrs: noOfHrs,
      totalDays: totalDays,
      totalHours: totalHours,
      durationType: durationType,
      effectiveStartDate: effectiveStartDate,
      effectiveEndDate: effectiveEndDate,
      startTime: startTime,
      reason: requestBody.reason,
      leaveName: requestBody.leaveName,
    };

    if (action === 'add') {
      addEmployeeMyTimeOff(
        employeeId,
        timeOffPayload,
        utcFisicalYearStartTime,
        utcFisicalYearEndTime,
      )
        .then(() => {
          toggleLoader(false);
          onClose();
          setOpen(true);
          setToastrVariable('success');
          setToastrId('myTimeOffAddedSuccessfully');
          setToastrDefaultMessage('Time Off added successfully');
          getTimeoffDetails();
        })
        .catch((error) => {
          toggleLoader(false);
          setToastrVariable('error');
          setOpen(true);
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            const errorResponse = error as ApiMessage;
            if (errorResponse.code === 1009 || errorResponse.code === 409) {
              setToastrId('TimeOffConflict');
              setToastrDefaultMessage(
                'Your Time off overlaps with an existing request. Adjust the dates or time to avoid conflict.',
              );
            } else if (errorResponse.code === 1015) {
              setToastrId('TimeOffConflictForHolidays');
              setToastrDefaultMessage(
                'No Time off is required for the chosen days or time.',
              );
            } else if (errorResponse.code === 1018) {
              setToastrId('myTimeOffExceedingMsg');
              setToastrDefaultMessage(
                `You can't submit a leave request exceeding your available balance.`,
              );
            } else if (errorResponse.code === 1029) {
              setToastrId('myTimeOffInvalidDates');
              setToastrDefaultMessage(
                `The dates selected are prior to the start date of the program or after the end date. Please choose different dates.`,
              );
            } else if (errorResponse.code === 1030) {
              setToastrId('myTimeOffActivitysheetError');
              setToastrDefaultMessage(
                `  Activity sheet has already been Approved for the selected dates. Choose different dates.`,
              );
            } else if (errorResponse.code === 1165) {
              setToastrId('myTimeDurationError');
              setToastrDefaultMessage(` Duration must be greater than zero.`);
            } else if (errorResponse.code === 1166) {
              setToastrId('myTimeOffStartDurationError');
              setToastrDefaultMessage(
                ` Start date and duration are required for hourly time-off.`,
              );
            } else if (errorResponse.code === 1167) {
              setToastrId('myTimeOffDurationFormatError');
              setToastrDefaultMessage(
                ` Duration entered is not a valid number.`,
              );
            } else if (errorResponse.code === 1168) {
              setToastrId('myTimeOffMultipleDatesError');
              setToastrDefaultMessage(
                `  The time-off cannot be applied  for Multiple dates.`,
              );
            }  
             else if (errorResponse.code === 1183) {
              setToastrId('myTimeOffApplyError');
              setToastrDefaultMessage(
                `You cannot apply more than 40 hours of Sick/LTI in a given Fiscal Year."
`,              );
            } 
            else {
              setToastrId('myTimeOffFailedToUpdate');
              setToastrDefaultMessage('Failed to update TimeOff');
            }
          }
        });
    } else {
      updateEmployeeMyTimeOff(
        employeeId,
        timeOffPayload,
        utcFisicalYearStartTime,
        utcFisicalYearEndTime,
      )
        .then(() => {
          onClose();
          toggleLoader(false);
          setOpen(true);
          setToastrVariable('success');
          setToastrId('myTimeOffUpdatedSuccessfully');
          setToastrDefaultMessage('Time Off updated successfully');
          getTimeoffDetails();
        })
        .catch((error) => {
          toggleLoader(false);
          setOpen(true);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            const errorResponse = error as ApiMessage;
            if (errorResponse.code === 1009 || errorResponse.code === 409) {
              setToastrId('TimeOffConflict');
              setToastrDefaultMessage(
                'Your Time off overlaps with an existing request. Adjust the dates or time to avoid conflict.',
              );
            } else if (errorResponse.code === 1015) {
              setToastrId('TimeOffConflictForHolidays');
              setToastrDefaultMessage(
                'No Time off is required for the chosen days or time.',
              );
            } else if (errorResponse.code === 1018) {
              setToastrId('myTimeOffExceedingMsg');
              setToastrDefaultMessage(
                `You can't submit a leave request exceeding your available balance.`,
              );
            } else if (errorResponse.code === 1029) {
              setToastrId('myTimeOffInvalidDates');
              setToastrDefaultMessage(
                `The dates selected are prior to the start date of the program or after the end date. Please choose different dates.`,
              );
            } else if (errorResponse.code === 1030) {
              setToastrId('myTimeOffActivitysheetError');
              setToastrDefaultMessage(
                `  Activity sheet has already been Approved for the selected dates. Choose different dates.`,
              );
            } else if (errorResponse.code === 1165) {
              setToastrId('myTimeDurationError');
              setToastrDefaultMessage(` Duration must be greater than zero.`);
            } else if (errorResponse.code === 1166) {
              setToastrId('myTimeOffStartDurationError');
              setToastrDefaultMessage(
                ` Start date and duration are required for hourly time-off.`,
              );
            } else if (errorResponse.code === 1167) {
              setToastrId('myTimeOffDurationFormatError');
              setToastrDefaultMessage(
                ` Duration entered is not a valid number.`,
              );
            } else if (errorResponse.code === 1168) {
              setToastrId('myTimeOffMultipleDatesError');
              setToastrDefaultMessage(
                `  The time-off cannot be applied  for Multiple dates.`,
              );
            } 
             else if (errorResponse.code === 1183) {
              setToastrId('myTimeOffApplyError');
              setToastrDefaultMessage(
                `You cannot apply more than 40 hours of Sick/LTI in a given Fiscal Year."
`,              );
            } 
            else {
              setToastrId('myTimeOffFailedToUpdate');
              setToastrDefaultMessage('Failed to update TimeOff');
            }
          }
        });
    }
  };

  const handleEditClick = (rowData: GetTimeOffListType) => {
    const startDate = rowData.effectiveStartDate
      ? moment(rowData.effectiveStartDate, 'YYYY-MM-DD')
        .format('MM/DD/YYYY')
      : null;
    const endDate = rowData.effectiveEndDate
      ? moment(rowData.effectiveEndDate, 'YYYY-MM-DD')
        .format('MM/DD/YYYY')
      : null;
    const startTime = rowData.startTime ?? null;

    setEditRowData({
      id: rowData.id,
      durationType: rowData.durationType,
      noOfHrs: rowData.noOfHrs,
      startDate: startDate,
      endDate: endDate,
      reason: rowData.reason,
      typeId: rowData.typeId,
      leaveName: rowData.leaveName,
      startTime: startTime,
      endTime: null,
    });
    setShowTimeOffModel(true);
  };
  const handleDeleteMyTimeOff = (id: string) => {
    toggleLoader(true);
    deleteEmployeeMyTimeOff(id)
      .then((res) => {
        if (res.code === 200) {
          if (myTimeOff.timeOffList.length === 1 && page > 0) {
            setPage(page - 1);
          } else {
            getTimeoffDetails();
          }
          fetchTbbTimeOffBalances();
          setOpen(true);
          setToastrVariable('success');
          setToastrId('myTimeOffDeletedSuccessfully');
          setToastrDefaultMessage(res.message);
        }
      })
      .catch((error) => {
        const response = error as ApiMessage;
        toggleLoader(false);
        setOpen(true);
        setToastrVariable('error');
        if (response.code === 1030) {
          setToastrId('myTimeOffActivitysheetErrorForApprovals');
          setToastrDefaultMessage(
            'Activity sheet has already been Submitted/Approved for the selected dates',
          );
        } else {
          setToastrId('myTimeOffFailedToDelete');
          setToastrDefaultMessage(error);
        }
      });
  };

  const getTimeoffDetails = () => {
    toggleLoader(true);
    const employeeId = localStorage.getItem(STORAGE_USER_ID_KEY);
    if (employeeId) {
      getEmployeeMyTimeOff(
        employeeId,
        page,
        startFisicalDateTime,
        endFisicalDateTime,
        order,
        orderBy,
        5,
        'Approved,Pending,Rejected,Accepted',
      )
        .then((res) => {
          if (res) {
            const employeeTypes = res.employeeTypeHistoryList.map(
              (item: EmployeeTypeHistoryList) => item.employeeType,
            );

            const filteredLeaves = res.leavesInfo.filter(
              (leave: TimeOffHours) =>
                employeeTypes.some((type) =>
                  leave.employeeType.split(',').includes(type),
                ),
            );

            toggleLoader(false);
            setMyTimeOff({
              leavesInfo: filteredLeaves,
              timeOffList: res.timeOffList,
              totalTimeOffsCount: res.totalTimeOffsCount,
              employeeType: res.employeeType,
              employeeTypeHistoryList: res.employeeTypeHistoryList,
            });
          }
        })
        .catch((error) => {
          toggleLoader(false);
          setOpen(true);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('failedProfileDetailsMessage');
            setToastrDefaultMessage('Failed to load profile details');
          }
        });
    }
  };

  useEffect(() => {
    if (selectedYear !== '') {
      getTimeoffDetails();
    }
  }, [page, order, selectedYear, orderBy]);

  const fetchTbbTimeOffBalances = () => {
    const employeeId = localStorage.getItem(STORAGE_USER_ID_KEY);
    const selectedProgramStr = localStorage.getItem(SELECTED_PROGRAM_KEY);
    if (
      employeeId &&
      selectedProgramStr &&
      startFisicalDateTime &&
      endFisicalDateTime
    ) {
      const programId = (JSON.parse(selectedProgramStr) as OptionType).id;
      getEmployeeTimeOffBalances(
        programId,
        employeeId,
        startFisicalDateTime,
        endFisicalDateTime,
      )
        .then((res) => {
          setTbbTimeOffBalances(res);
        })
        .catch((error) => {
          console.error('Failed to load TBB time off balances', error);
          setOpen(true);
          setToastrVariable('error');
          if (isCustomError(error)) {
            const apiError = error as ApiError;
            setToastrId(apiError.id);
            setToastrDefaultMessage(apiError.message);
          } else {
            setToastrId('failedProfileDetailsMessage');
            setToastrDefaultMessage('Failed to fetch Employee Time off Summary cards');
          }
        });
    }
  };

  useEffect(() => {
    fetchTbbTimeOffBalances();
  }, [startFisicalDateTime, endFisicalDateTime]);

  useEffect(() => {
    if (
      (checkPermissionForFeature('backend.time_off', 'editPermission') ||
        checkPermissionForFeature('backend.time_off', 'deletePermission')) &&
      headCells.length === 5
    ) {
      setHeadCells((prev) => [
        ...prev,
        {
          id: 'actions',
          labelId: 'myTimeOffActions',
          defaultLabelId: 'Actions',
          numeric: false,
          requiredSorting: false,
        },
      ]);
    }
    return () => {
      setHeadCells(initialHeadCells);
    };
  }, []);

  const tableContainerRef = useRef<HTMLDivElement>(null);
  const balanceContainerRef = useRef<HTMLDivElement>(null);
  const [balancePage, setBalancePage] = useState(0);
  const [balanceContainerWidth, setBalanceContainerWidth] = useState(0);
  const [tableWidth, setTableWidth] = useState<number | null>(null);
  const balanceItemWidth = 210;

  const blocks = myTimeOff.leavesInfo.map((data) => {
    if (
      (data.type === 'Sick/LTI' ||
        myTimeOff.employeeType === 'Salaried Exempt') &&
      data.type !== 'Others'
    ) {
      return (
        <Grid
          key={data.id}
          item
          className="pb-md mr-md"
          sx={{ width: '195px !important' }}
        >
          <Box
            sx={{
              borderRadius: '6px',
              border: '1px solid #00C6B8',
            }}
          >
            <CardContent
              sx={{
                padding: '12px',
              }}
            >
              <MediumTypography
                label={data.type}
                sxProps={{
                  padding: '4px',
                  backgroundColor: '#B1FDF7',
                  fontSize: '12px',
                  fontWeight: 700,
                  borderRadius: '4px',
                  color: '#2A4241',
                  whiteSpace: 'nowrap',
                  textAlign: 'center',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  paddingTop: '10px',
                }}
              >
                <MediumTypography
                  labelid="myTimeOffHours"
                  defaultlabel="Available Hours"
                  sxProps={{
                    fontSize: '12px',
                    color: '#97A6A5',
                    whiteSpace: 'nowrap',
                  }}
                />
                <MediumTypography
                  label={convertTimeDuration(data.remainingHrs, true)}
                  sxProps={{
                    fontSize: '16px',
                    fontWeight: 800,
                    color: '#2A4241',
                    whiteSpace: 'nowrap',
                  }}
                />
              </Box>
            </CardContent>
          </Box>
        </Grid>
      );
    }
  });

  const tbbBalanceCards = tbbTimeOffBalances.map((item) => (
    <Box
      key={item.name}
      sx={{ width: '202px', flexShrink: 0 }}
    >
      <TimeOffBalancesCard data={item} />
    </Box>
  ));

  const balanceItemsPerPage = Math.max(
    1,
    Math.floor(balanceContainerWidth / balanceItemWidth),
  );
  const totalBalancePages = Math.max(
    1,
    Math.ceil(tbbBalanceCards.length / balanceItemsPerPage),
  );

  useEffect(() => {
    const updateWidths = () => {
      if (tableContainerRef.current) {
        setTableWidth(tableContainerRef.current.offsetWidth);
      }
      if (balanceContainerRef.current) {
        setBalanceContainerWidth(balanceContainerRef.current.offsetWidth);
      }
    };
    updateWidths();
    window.addEventListener('resize', updateWidths);
    return () => window.removeEventListener('resize', updateWidths);
  }, [tbbBalanceCards.length, myTimeOff.timeOffList.length]);

  useEffect(() => {
    if (balancePage > totalBalancePages - 1) {
      setBalancePage(Math.max(0, totalBalancePages - 1));
    }
  }, [totalBalancePages, balancePage]);

  const handleBalancePageChange = (direction: 'left' | 'right') => {
    setBalancePage((prev) => {
      if (direction === 'left') return Math.max(0, prev - 1);
      return Math.min(totalBalancePages - 1, prev + 1);
    });
  };

  return (
    <>
      {confirmationModal && (
        <ModalPopup
          open={confirmationModal}
          description="TimeOff.deleteConfirmationMessage"
          onCancel={() => setConfirmationModal(false)}
          onOk={() => {
            if (deleteTimeOff?.id !== undefined) {
              handleDeleteMyTimeOff(deleteTimeOff.id);
            }
            setDeleteTimeOff(null);
            setConfirmationModal(false);
          }}
          labelId1="TimeOff.No"
          negativeActionLabel="No"
          labelId2="TimeOff.Yes"
          positiveActionLabel="Yes"
        />
      )}
      <SnackBarComponent
        open={open}
        handleClose={handleClose}
        successOrError={toastrVariable}
        labelId={toastrId}
        defaultMessageId={toastrDefaultMessage}
      />
      {tbbTimeOffBalances.length > 0 && (
        <Box
          className="mb-md"
          sx={{ width: tableWidth ? `${tableWidth}px` : '100%' }}
        >
          <Card>
            <CardContent sx={{ padding: '16px' }}>
              <MediumTypography
                labelid="timeOutLogsText"
                defaultlabel="Time Out Logs"
                sxProps={{
                  fontSize: '16px',
                  fontWeight: 700,
                  color: '#2A4241',
                  paddingBottom: '12px',
                }}
              />
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                  onClick={() => handleBalancePageChange('left')}
                  disabled={balancePage === 0}
                  sx={{ flexShrink: 0 }}
                >
                  <img
                    src={backarrow}
                    alt="previous"
                    style={{ filter: 'brightness(0) saturate(100%)' }}
                  />
                </IconButton>
                <Box
                  ref={balanceContainerRef}
                  sx={{
                    overflow: 'hidden',
                    flex: 1,
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      flexWrap: 'nowrap',
                      transform: `translateX(-${
                        balancePage * balanceItemsPerPage * balanceItemWidth
                      }px)`,
                      transition: 'transform 0.3s ease',
                       gap: '8px',
                    }}
                  >
                    {tbbBalanceCards}
                  </Box>
                </Box>
                <IconButton
                  onClick={() => handleBalancePageChange('right')}
                  disabled={balancePage >= totalBalancePages - 1}
                  sx={{ flexShrink: 0 }}
                >
                  <img
                    src={backarrow}
                    alt="next"
                    style={{
                      filter: 'brightness(0) saturate(100%)',
                      transform: 'rotate(180deg)',
                    }}
                  />
                </IconButton>
              </Box>
            </CardContent>
          </Card>
        </Box>
      )}
      <Box>
        <Card
          sx={{
            borderBottomLeftRadius: '0px',
            borderBottomRightRadius: '0px',
          }}
        >
          <CardContent
            sx={{
              padding: '16px 16px 0px 16px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <TitleText
                labelid="myTimeOffTitle"
                defaultlabel="My Time Off"
                Sxprops={{
                  fontSize: '16px',
                  fontWeight: 700,
                  color: '#2A4241',
                  textAlign: 'left',
                }}
              />
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  flexGrow: 1,
                }}
              >
                <Box sx={{ width: '25%' }}>
                  <SelectComponent
                    value={selectedYear}
                    handleChange={(value) => {
                      setSelectedYear(value);
                      handleYearChange(value);
                    }}
                    names={fisicalYears}
                    height="32px"
                  />
                </Box>
                <ButtonComponent
                  className="btn-primary btn-submitBorder btn-cancel ml-md"
                  variantType="outlined"
                  type="submit"
                  labelId="myTimeOFFAvailableHours"
                  defaultLabelId="Available Hours"
                  sxProps={{
                    border: '1px solid #008C82',
                    display: 'none',
                  }}
                  onClick={() => {
                    handleAvailableHrs();
                  }}
                />
                {checkPermissionForFeature(
                  'backend.time_off',
                  'addPermission',
                ) && (
                    <ButtonComponent
                      className="btn-primary btn-submit ml-md"
                      variantType="contained"
                      type="submit"
                      labelId="myTimeOffRequestButtonTitle"
                      defaultLabelId="Request"
                      disabled={
                        selectedYear !== '' &&
                        selectedYear.split('-').map(Number)[1] <
                        new Date().getFullYear()
                      }
                      onClick={() => handleTimeOff()}
                    />
                  )}
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
      {showTimeOffModel && (
        <MyTimeOffModal
          timeoffBalancelogs={tbbTimeOffBalances}
          open={showTimeOffModel}
          handleClose={onClose}
          rowData={editRowData}
          selectedYear={selectedYear}
          availableHrs={myTimeOff.leavesInfo}
          handlesubmit={(values: TimeOffListType, action: string) => {
            handleSubmit(values, action);
          }}
        />
      )}
      {availableHrs && (
        <Modal
          open={availableHrs}
          onClose={() => {
            onCloseModal();
          }}
        >
          <Box
            sx={myTimeOff.employeeType === 'Salaried Exempt' ? style : style400}
          >
            <Card
              sx={{
                width: '100%',
                borderRadius: '6px',
              }}
            >
              <CardContent className="p-xlg">
                <Box className="flex__ justifyContent-FlexEnd ">
                  <Close
                    className="cursorPointer"
                    onClick={() => onCloseModal()}
                  />
                </Box>
                <Box>
                  <MediumTypography
                    labelid="myTimeOFFAvailableHours"
                    defaultlabel="Available Hours"
                    sxProps={{
                      fontSize: '24px',
                      fontWeight: 700,
                      paddingBottom: '24px',
                    }}
                  />
                  <Grid container direction={'row'}>
                    {blocks}
                  </Grid>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </Modal>
      )}

     

      <TableContainer component={Paper} ref={tableContainerRef}>
        <Table aria-label="simple table">
          <TableHeader
            headerNames={headCells}
            checkBoxRequired={false}
            onRequestSort={handleRequestSort}
            order={order}
            orderBy={orderBy}
            className="listDataTableHead"
          />
          <TableBody className="tableRowcss">
            {myTimeOff.timeOffList.length !== 0 &&
              myTimeOff.timeOffList.map((timeOffData) => (
                <MyTimeOffTableRow
                  data={timeOffData}
                  key={timeOffData.id}
                  onEdit={handleEditClick}
                  onDeleteMyTimeOff={() => {
                    if (timeOffData.id !== undefined) {
                      setDeleteTimeOff(timeOffData);
                      setConfirmationModal(true);
                    }
                  }}
                />
              ))}
          </TableBody>
        </Table>
        {myTimeOff.timeOffList.length === 0 && !loader && (
          <Box
            sx={{
              width: '100%',
            }}
          >
            <MediumTypography
              textstyle={'center'}
              labelid="noTimeOffMessage"
              defaultlabel="No request added yet"
              paddingstyle="12px"
            />
          </Box>
        )}
      </TableContainer>

      {myTimeOff.totalTimeOffsCount > 5 && (
        <Card
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <AppPagination
            pageNumber={page}
            perPageCount={5}
            paginationCount={myTimeOff.totalTimeOffsCount}
            handleChangePage={(_event, newPage) => {
              if (newPage - 1 !== page) {
                setPage(newPage - 1);
              }
            }}
          />
        </Card>
      )}
    </>
  );
};

export default MyTimeOff;
